import { render, staticRenderFns } from "./Much.vue?vue&type=template&id=648082be&scoped=true"
import script from "./Much.vue?vue&type=script&lang=ts"
export * from "./Much.vue?vue&type=script&lang=ts"
import style0 from "./Much.vue?vue&type=style&index=0&id=648082be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648082be",
  null
  
)

export default component.exports